import envConfig from './env.json';

// Interface para tipar as variáveis de ambiente
interface EnvironmentConfig {
  API_URL: string;
  WIDGET_URL: string;
}

// Configurações do ambiente
export const env: EnvironmentConfig = {
  API_URL: envConfig.API_URL,
  WIDGET_URL: envConfig.WIDGET_URL,
};

// Exportações individuais para facilitar o uso
export const { API_URL, WIDGET_URL } = env;

// Exportação padrão
export default env; 